import CrudSection from "./CrudSection";

const FIELDS = [
  { name: "title", label: "Title", type: "text", required: true, full: true, placeholder: "Course title" },
  { name: "description", label: "Description", type: "textarea", full: true, placeholder: "Short course description" },
  { name: "tag", label: "Tag / Badge", type: "text", placeholder: "e.g. New, 3 Levels, Career" },
  { name: "duration", label: "Duration", type: "text", placeholder: "e.g. 40 hours" },
  { name: "image", label: "Image URL", type: "text", full: true, placeholder: "https://…" },
  { name: "offer_link", label: "Offer link", type: "text", full: true, placeholder: "Optional discount URL" },
  { name: "whatsapp_link", label: "WhatsApp CTA URL", type: "text", full: true, placeholder: "https://wa.me/91…" },
  { name: "order", label: "Order", type: "number", placeholder: "0" },
  { name: "active", label: "Active", type: "checkbox", placeholder: "Show on website" },
];

export default function AdminCourses() {
  return (
    <CrudSection
      title="Courses"
      endpoint="courses"
      testIdPrefix="course"
      fields={FIELDS}
      defaultValues={{ active: true, order: 0 }}
      renderRow={(c) => (
        <div className="flex items-center gap-4">
          {c.image ? (
            <img
              src={c.image}
              alt=""
              className="w-14 h-14 rounded-xl object-cover border border-[#1F2547]/10"
            />
          ) : (
            <div className="w-14 h-14 rounded-xl bg-[#EFE9F7]" />
          )}
          <div className="min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="font-display font-bold text-base text-[#1F2547] truncate">
                {c.title}
              </h3>
              {c.tag && (
                <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-[#D4EDDB] text-[#1F2547]">
                  {c.tag}
                </span>
              )}
              {!c.active && (
                <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-red-50 text-red-600">
                  Hidden
                </span>
              )}
            </div>
            <p className="text-sm text-[#5B6079] line-clamp-2">{c.description}</p>
            <div className="text-xs text-[#5B6079] mt-1 font-medium">
              {c.duration ? `${c.duration} · ` : ""}order #{c.order}
            </div>
          </div>
        </div>
      )}
    />
  );
}
